import { api } from "..";
import { CryptoSweepSettingValue } from "./types";

// Dedicated, step-up protected write path for the crypto sweep (treasury) config.
// The global axios interceptor handles the STEP_UP_REQUIRED challenge.
export async function updateCryptoSweep(
  value: CryptoSweepSettingValue
): Promise<{ value: CryptoSweepSettingValue }> {
  const res = await api.client.put("/app-settings/crypto-sweep", { value });
  return res.data;
}
